import { Observable, ReplaySubject, Subject } from 'rxjs';

import { ObservableScope } from '../models/observable-scope.enum';

export interface ScopableObservable<T> {
    /**
     * NOTE: Using ScopableSubject (that implements ScopableObservable) is prone to memory leak because events / messages
     * will be stored indefinitely for ReplaySubject
     * @param scope ObservableScope
     */
    withScope(scope: ObservableScope): Observable<T>;
}

export class ScopableSubject<T> implements ScopableObservable<T> {
    private readonly onlyFuture: Subject<T> = new Subject();
    private readonly pastAndFuture: Subject<T> = new ReplaySubject();

    public withScope(scope: ObservableScope): Observable<T> {
        switch (scope) {
            case ObservableScope.OnlyFuture:
                return this.onlyFuture.asObservable();
            case ObservableScope.PastAndFuture:
                return this.pastAndFuture.asObservable();
            default:
                throw new Error('Unknown Observable Scope');
        }
    }

    public next(entry: T) {
        this.onlyFuture.next(entry);
        this.pastAndFuture.next(entry);
    }

    public asScopableObservable(): ScopableObservable<T> {
        return this;
    }
}
